import React from "react";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import FormDropDown from "../../../common/layout/form/FormDropDown";
import NewFormBtns from "../../../common/layout/form/NewFormBtns";
import { validationSchemaPrice } from "../../actions/validationSchema";
import { dropDownS } from "../../styles/dropDown.styles";
import Price from "./Price";

export interface PriceFormShortProps {
  handleSubmit: any;
  orderTypesItems: Array<any>;
  initValues: any;
  cancelForm: any;
}

const PriceFormShort: React.FC<PriceFormShortProps> = ({
  handleSubmit,
  orderTypesItems,
  initValues,
  cancelForm,
}) => {
  const { t } = useTranslation("admin");
  return (
    <Formik
      initialValues={initValues}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      validationSchema={validationSchemaPrice}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className={dropDownS}>
            <FormDropDown
              headerText={t("nav.panelType") as string}
              name="orderTypeItemId"
              options={orderTypesItems}
            />
          </div>
          <div>
            <Price name="price" label={t("nav.price") as string} />
          </div>

          <NewFormBtns
            cancelForm={cancelForm}
            submitBtnText={t("nav.add") as string}
            positionAbsolute={true}
          />
        </form>
      )}
    </Formik>
  );
};

export default PriceFormShort;